<template>
  <div class="member__recommend">
    <div v-for="(item,index) in goods" :key="index"
         :mg-stat-custom="`cont=${item.goodsId}&label=goods&direct=cntp&addr=haowu_goods_detail`"
         :mg-stat-lob="`goodsdc=${goodsdc}`" class="member__recommend__item"
         mg-stat-click
         mg-stat-mod="recommend"
         @click="goGoodsDetail(item.goodsId,goodsdc)">
      <img :src="item.originalImg"/>
      <p class="name">{{ item.goodsName }}</p>
      <p class="price">￥{{ item.shopPrice }} <span class="desc"><span class="vtag">VIP</span><span class="tag">￥</span>{{
          item.memberGoodsPrice
        }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import { guid } from 'utils';

export default {
  props: {
    goods: {
      type: Array,
    },
  },
  data() {
    return {
      goodsdc: this.guid(),
    };
  },
  methods: {
    guid,
    goGoodsDetail(id) {
      this.$router.push({ path: '/goods/detail', query: { id, showBack: 1, goodsdc: this.goodsdc } });
    },
  },
};
</script>
<style lang="scss" scoped>
.member {
  &__recommend {
    //padding:0px 30px;
    &__item {
      display: inline-block;
      width: 330px;
      color: #fff;
      border-radius: 10px;
      background-color: #fff;
      margin: 20px 10px 0px 10px;
      box-shadow: 0px 6px 16px -2px rgba(0, 0, 0, 0.1);
      border-radius: 10px;

      img {
        width: 100%;
        height: 340px;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
      }

      p {
        font-size: 28px;
        color: #000;
        padding: 10px;
      }

      p.name {
      }

      p.price {
        color: rgba(255, 43, 60, 1);
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        text-align: left;
        position: relative;

        span.desc {
          margin-left: 10px;
          position: absolute;
          top: 18px;
          font-size: 22px;
          // width: 108px;
          height: 31px;
          color: rgba(40, 35, 35, 1);
          // background-size:  108px 32px;
          background: linear-gradient(to right, #282323 40%, #FAEFE1 30%);
          box-sizing: border-box;
          line-height: 33px;
          padding-right: 5px;
          border-radius: 4px;

          .vtag {
            padding: 0px 5px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            font-size: 22px;
            color: #FAEFE1;
          }

          .tag {
            font-size: 12px;
            color: rgba(40, 35, 35, 1);
            margin-left: 0px;
            text-decoration: none;
            border: none;
            margin-left: 2px;
          }
        }

        span.price {
          // color: #000;
          font-size: 24px;
          color: rgba(186, 133, 69, 1);
        }
      }

      &-btn {
        display: block;
        width: 100%;
        height: 50px;
        font-size: 30px;
        line-height: 30px;
        text-align: center;
        border-radius: 10px;
        color: #fff;
        background-color: #c3c3c3;
      }
    }
  }
}
</style>
